import { render, staticRenderFns } from "./LogoutSubmit.vue?vue&type=template&id=7a6846d5&scoped=true"
import script from "./LogoutSubmit.vue?vue&type=script&lang=js"
export * from "./LogoutSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6846d5",
  null
  
)

export default component.exports